import {Directive, Input} from '@angular/core';
import {UiWidget} from '@pt/pt-models';
import {StoreTemplateStatus} from '../../../../../pt-models/src/lib/custom/store-template-status';

@Directive()
export abstract class WidgetInputDirective {
  @Input() initializationWidget: UiWidget;
  @Input() status: StoreTemplateStatus;
  @Input() lockAcquired: boolean;
}
